import React, { Component, Fragment } from 'react';
import { InputGroup, FormGroup } from 'react-nice-inputs';

// Componentss
import DateRangePicker from 'js/components/step1/DateRangePicker';
import { VacationContext } from 'js/components/step1/VacationContext';
import AddGuests from 'js/components/step1/AddGuests';
import MegaMenu from 'js/components/step1/MegaMenu';
import Collapsible from 'js/components/global/collapsible/Collapsible';
import TooltipWrapper from 'js/components/global/TooltipWrapper';
// import InclusionsModalWrapper from 'js/components/step1/InclusionsModalWrapper'; code commented in 26/09/22 - maybe this code return in the future.
// import ReopeningModalWrapper from 'js/components/step1/ReopeningModalWrapper';
import DataService from 'js/modules/dataservice';
import moment from 'moment';
import ErrorModalWrapper from 'js/components/global/ErrorModalWrapper';
import ResortPicker from '../../components/step1/ResortPicker';
import Modal from '../../components/global/Modal';
import Tabs from '../../components/global/tabs/Tabs';
import TabItem from 'js/components/global/tabs/TabItem';
import Compare from './Compare';
import constants from 'js/modules/constants';

const _internals = {
  brands: {
    s: 'Sandals',
    b: 'Beaches',
  },
};

// const isMobile = window.innerWidth < 768;
// const isTable = window.innerWidth >= 768 && window.innerWidth < 1023;

const paramNames = Object.keys(_app.urlparams);
const params = {};

// params from QQ comming in Uppercase
if (paramNames) {
  paramNames.map((name) => {
    params[`${name.toLowerCase()}`] = _app.urlparams[name] || '';
  });

  if (params.hasOwnProperty('startdate')) {
    const nativeStartDate = new Date(params.startdate.replace(/-/g, '/'));

    params.startdate =
      params.startdate === ''
        ? ''
        : moment(nativeStartDate).format('YYYY-MM-DD');

    if (params.startdate === 'Invalid date') {
      params.startdate = '';
    }
  }

  if (params.hasOwnProperty('departuredate')) {
    const nativeDepartureDate = new Date(
      params.departuredate.replace(/-/g, '/')
    );

    params.departuredate =
      params.departuredate === ''
        ? ''
        : moment(nativeDepartureDate).format('YYYY-MM-DD');

    if (params.departuredate === 'Invalid date') {
      params.departuredate = '';
    }
  }
}

const maxWidthStyle = {
  maxWidth: 'none',
};

class VacationDates extends Component {
  state = {
    modalIsOpen: {
      inclusions: true,
      bestPriceGuarante: false,
    },
    gateways: [],
    resortGateways: [],
    // flightInfo: {
    //   departure_airport: '',
    //   flight_type: 'economy',
    // },
    isOpen: false,
    isGuestControlOpen: false,
    currentValue: 'false',
    brandOptions: window._app.brandOptions,
    flightDisclamerDates: [],
    saintVincentBookingDates: {},
  };

  async componentDidMount() {
    // this._setTooltipInitialState(params);
    const gatewaysResponse = await DataService.readGateways();
    const resortGatewaysResponse = await DataService.readResortGateways();
    const { code, content } = gatewaysResponse;
    const resortGateways = resortGatewaysResponse.content;
    const gateways = [];
    // const disclaimerURL =
    //   'https://cdn.sandals.com/obe/v12/resources/flight_disclaimer.json';
    // const flightDisclamerResponse = await fetch(disclaimerURL).then(
    //   (response) => response.json()
    // );

    // console.log(flightDisclamerResponse);

    const saintVincentDatesResponse = window._app.results.flightRestrictions;

    content.map((item) => {
      gateways.push({
        label: this._buildGatewaysLabel(item),
        value: item.gateway.toLowerCase(),
        attrs: {
          'data-countryid': item.gateway.toLowerCase(),
          'data-stateid': item.state,
          'data-city': item.city,
        },
      });
    });

    if (code === 1) {
      this.setState({
        gateways,
        resortGateways,
        // flightDisclamerDates: flightDisclamerResponse.flightDates,
        saintVincentBookingDates: saintVincentDatesResponse,
      });
    } else {
      this.setState({saintVincentBookingDates: saintVincentDatesResponse});
    }
  }

  /* Builds the gateway label */
  _buildGatewaysLabel = (item) => {
    // const labelElement = (<Fragment>
    //   <div className="d-none">{ item.stateName }</div>
    //   { item.city }, { item.state } { item.country }, ({ item.gateway.toUpperCase() })
    // </Fragment>);

    // return labelElement;

    const { city, state, stateName = '', country, gateway } = item;
    const stateId = country.toUpperCase() === 'USA' ? `(${state})` : '';
    let finalStateString = '';

    if (stateName.length === 0 && stateId.length > 0) {
      finalStateString = `${stateId.replace('(', '').replace(')', '')},`;
    } else if (stateName.length === 0 && stateId.length === 0) {
      finalStateString = '';
    } else {
      finalStateString = `${stateName}${stateId},`;
    }

    return `${city}, ${finalStateString} ${country} (${gateway.toUpperCase()})`;
  };

  /* Sets Add Guest Control initial state based on the number of children in the url params */
  _setTooltipInitialState = () => {
    /*
    const { noofchildren = 0 } = parameters;
    (noofchildren > 0) && this.setState({ isGuestControlOpen: true });*/

    this.setState({ isGuestControlOpen: true });
  };

  _getBrandName = () => _internals.brands[window._app.brand];

  airportName = (name) => (name ? `${name}, ` : '');

  updateFlightInfo = (rawValue, name, context) => {
    // const flightInfo = { ... this.state.flightInfo };
    let value = rawValue;
    // flightInfo[name] = value;

    if (name === 'airIncluded') {
      value = rawValue === 'true';

      context.toggleRequired(['departure_airport', 'flight_type'])();

      context.setInputValue(value, name);
    }

    if (!value) {
      // desperate situation requires desperate measures
      context.state.fields.departure_airport = '';
      context.state.fieldValidations.departure_airport = true;
    }

    context.setInputValue(value, name);

    // this.setState({ flightInfo });
  };

  toggleToolTip = (context, value) => {
    const { isOpen } = this.state;

    context.setInputValue(value, 'adjoiningRoom');

    this.setState({ isOpen: !isOpen, currentValue: value });
  };

  _renderErrors = (addGuestErrorDetails = {}) => {
    const errorLabels = Object.keys(addGuestErrorDetails);

    if (errorLabels) {
      return errorLabels.map((error) => {
        const noField = error.split('_')[2];
        const fieldType = error.split('_')[3];
        const guestNo = parseInt(noField, 10) + 1;

        return (
          <p key={`${fieldType}_${noField}`} className="is-invalid">
            Please select age of {fieldType} {guestNo} or date is invalid.
          </p>
        );
      });
    }

    return '';
  };

  /**
   * Method to check if the current resort applies for the "arrival airport" option in the flight section.
   * @param {String} checkInDate
   * @param {String} checkOutDate
   * @param {String} verificationDate
   * @returns true if the dates applies for the arrival gateway otherwise return false
   */
  _applyForArrivalGatewayVerification(
    checkInDate,
    checkOutDate,
    verificationDate
  ) {
    const mCheckInDate = moment(checkInDate);
    const mCheckOutDate = moment(checkOutDate);
    const mverficationDate = moment(verificationDate);
    const checkInDay = mCheckInDate.format('dddd');
    const checkOutDay = mCheckOutDate.format('dddd');
    let areValidDates = false;
    const disclaimerDays = this.state.flightDisclamerDates; // this is the json disclaimer of the cnd

    if (mCheckInDate.diff(mverficationDate, 'days') >= 0) {
      (checkInDay === disclaimerDays[0] || checkInDay === disclaimerDays[1]) &&
      (checkOutDay === disclaimerDays[0] || checkOutDay === disclaimerDays[1])
        ? (areValidDates = true)
        : (areValidDates = false);
    }

    return areValidDates;
  }

  /**
   * Method to check if the vacation dates for the Saint Vincent resort applied to book with flights.
   * @param {String} checkInDate
   * @param {String} checkOutDate
   * @returns returns true if the dates applied for flights otherwise will return false.
   */
  _applyForSanVincentGateway(checkInDate, checkOutDate, rstCode) {
    const mCheckInDate = moment(checkInDate);
    const mCheckOutDate = moment(checkOutDate);
    const checkInDay = mCheckInDate.format('dddd');
    const checkOutDay = mCheckOutDate.format('dddd');
    const validDates = this.state.saintVincentBookingDates ? this.state.saintVincentBookingDates[rstCode] : {};
    const validFlightDates = Object.keys(validDates).length > 0 ? validDates.mia.concat(validDates.yyz) : [];
    const compress = [... new Set(validFlightDates)];
    let areValidDates = 0;

    if(compress && compress.length > 0) {
      compress.map((validDate) => {
        if(checkInDay === validDate || checkOutDay === validDate) {
          areValidDates++;
        }
      });

      return areValidDates > 1;
    }


    return true;
  }

  render() {
    const brand = this._getBrandName();
    const {
      isSandals = false,
      title = '',
    } = window._app.brandOptions;
    const cookiesEnabled = navigator.cookieEnabled;
    const minFlightDate = moment().add(14, 'days');
    const promoActive = false;

    return (
      <Fragment>
        {/* isSandals && (
          <div className="container dates-tabs">
            <p className="sm-6 lg-5 tab active">Specific Dates</p>
            <a className="sm-6 lg-5 tab" href="https://www.sandals.com/flexible-dates/">Flexible Dates</a>
          </div>
        ) */}
        <div className="specific-dates">
          <div className="container " style={{ position: 'relative', zIndex: 1 }}>
            {!cookiesEnabled && (
              <ErrorModalWrapper
                isOpen={!cookiesEnabled}
                title="Online Booking Engine has found an error:"
              >
                <div className="util-txt-left error-content row">
                  <div className="sm-12">
                    <br />
                    <em style={{ color: 'red', fontStyle: 'normal' }}>
                      Cookies disabled.
                    </em>
                    <br />
                    To use our online booking engine you have to enable cookies in
                    your browser settings and refresh.
                    <br />
                    <br />
                    <a href="https://www.nap.edu/content/enabling-cookies-in-your-browser">
                      <b>Learn more</b>
                    </a>
                  </div>
                </div>
              </ErrorModalWrapper>
            )}

            {/* This section was commented in 26/09/22 - maybe will return in the future.
            <section className="quality-container row util-txt-center">
              <div className="sm-12 md-8 lg-12 md-offset-2 lg-offset-0">
                <h3 className="heading-quality">
                  More Quality Inclusions
                  <span className="d-sm-block d-md-block">
                    {' '}
                    than any other resort on the planet
                  </span>
                </h3>

                <VacationContext.Consumer>
                  {(context) => (
                    <a
                      className="blue-link"
                      onClick={(e) => context.openModal('inclusions', e)}
                    >
                      <i className="icon-bold-arrow" /> View Inclusions
                    </a>
                  )}
                </VacationContext.Consumer>
              </div>

              <InclusionsModalWrapper brand={brand} />
            </section>
            */}

            {/* <ReopeningModalWrapper brand={brand} /> */}

            <VacationContext.Consumer>
              {(context) => {
                const { warning } = context.state;

                return (
                  <Fragment>
                    {!warning &&
                      window._app.urlparams.sessionexpired === 'true' && (
                        <p className="fields-error util-txt-center">
                          Your session has been closed due to inactivity.
                        </p>
                      )}
                    {warning && (
                      <div className="fields-error-container">
                        <p className="fields-error util-txt-center">
                          Please check the highlighted fields for errors.
                        </p>
                      </div>
                    )}
                  </Fragment>
                );
              }}
            </VacationContext.Consumer>
            <section className="row limited-time-offer">
              {isSandals && promoActive ?
                <div className="description-variant sm-12 md-11 lg-10">
                  <picture className="limited-image">
                    <source media="(min-width: 768px)" srcSet="https://cdn.sandals.com/obe/v12/images/banners/indenpence-weekend/us-flag-cut.png" />
                    <img className="-img" src="https://cdn.sandals.com/obe/v12/images/banners/indenpence-weekend/us-flag-cut-mobile.png" alt="US Flag" />
                  </picture>
                  <p className="limited">Independence Weekend Special</p>
                  <p className="online-credit">Extra $150 Off</p>
                  <p className="online-credit-mobile">Extra $150 Off</p>
                </div> :
                <div className="description sm-12 md-11 lg-10">
                  <p className="limited">LIMITED TIME OFFER</p>
                  <p className="online-credit">Book Online Today & Get $100 Off</p>
                  <p className="online-credit-mobile">Book Online & Get $100 Off</p>
                </div>
              }
            </section>
            <section className="row dark-form">
              <div className="sm-12 md-11 lg-10 group">
                <div className="row">
                  <div className="sm-12">
                    <h3 className="primary-heading">Select {brand} Resort:</h3>
                  </div>
                  <div className="sm-12 select-resort">
                    <VacationContext.Consumer>
                      {(context) => {
                        const { fieldValidations, fields } = context.state;
                        const { rstCode } = fieldValidations;
                        const resortGateways = this.state.resortGateways;
                        let resortCode = '';

                        // The filled fields have priority over the QQ parameters.
                        if (context.state.vacationData.checkInDate) {
                          resortCode = context.state.vacationData.rstCode.toLowerCase();
                        } else {
                          resortCode = params.rst_code
                            ? params.rst_code.toLowerCase()
                            : '';
                        }

                        return (
                          <Fragment>
                            <MegaMenu
                              name="rstCode"
                              onChange={context.setInputValue}
                              brand={window._app.brand}
                              attrs={{
                                autoComplete: 'off',
                                placeholder: `Select ${title} Resort...`,
                              }}
                              isRstCode={rstCode}
                              value={resortCode}
                              fields={fields}
                              resortGateways={resortGateways}
                            />

                            {/* {isSandals && (
                              <div className="sm-12 md-6 need-help">
                                <p>
                                  Need Help Deciding?
                                </p>
                                <a
                                  className="blue-link"
                                  href="https://www.sandals.com/vacation-planner/"
                                >
                                  Find The Sandals That Is Right For You {' '}
                                  <i className="icon-bold-arrow" />
                                </a>
                              </div>
                            )} */}

                            <Modal
                              isOpen={context.state.isModalOpen.resortPicker}
                              onRequestClose={context.closeModal('resortPicker')}
                              className="resort-picker-modal fok-title"
                            >
                              <h3 className="primary-heading">FIND YOUR SANDALS</h3>
                              <Tabs>
                                <TabItem className="tab" label="FILTER RESORTS">
                                  <ResortPicker />
                                </TabItem>

                                <TabItem className="tab" label="COMPARE RESORTS">
                                  <Compare />
                                </TabItem>
                              </Tabs>
                            </Modal>
                          </Fragment>
                        );
                      }}
                    </VacationContext.Consumer>
                  </div>
                  {/*
                    <div className="sm-12 lg-6">
                      <h4 className="secondary-heading">Not sure which resort to pick?</h4>
                      <ul className="list-confused-af">
                        <li>
                          <a href="#">
                            <i className="icon-bold-arrow accent-color" />
                            Sandals Resort Quick Facts
                          </a>
                        </li>
                        {
                          isSandals &&
                          <li>
                            <a href={`/vacation-planner/?subSessionId=${window._app.page.subSessionId}`}>
                              <i className="icon-bold-arrow rst-pick accent-color" />
                              Help Finding your Sandals Resort
                            </a>
                          </li>
                        }
                        <li>
                          <a href={`/compare/?subSessionId=${window._app.page.subSessionId}`}>
                            <i className="icon-bold-arrow rst-pick accent-color" />
                            Compare {title} Resorts
                          </a>
                        </li>
                      </ul>
                    </div>
                  */}
                </div>
              </div>
              <div className="group-divider"/>
              <div className="sm-12 md-11 lg-10 group">
                <h3 className="primary-heading">Select Vacation Dates:</h3>
                <VacationContext.Consumer>
                  {(context) => {
                    const { fieldValidations, showLessThan3NightsWarning, fields } = context.state;
                    const { checkInDate, checkOutDate } = fieldValidations;

                    const tomorrow = moment().add(2, 'days');
                    const oneWeek = moment().add(8, 'days');

                    const {
                      checkInDate: startDate = tomorrow,
                      checkOutDate: endDate = oneWeek,
                    } = context.state.vacationData;

                    // Values if user comes from QQ website
                    // why undefined? well for moment, undefined is the same as moment()
                    // so instead of empty string send undefined
                    params.startdate =
                      params.startdate === '' ? undefined : params.startdate;
                    params.departuredate =
                      params.departuredate === ''
                        ? undefined
                        : params.departuredate;

                    const quickQuoteParams = {
                      initialStartDate:
                        params.startdate && moment(params.startdate),
                      initialEndDate:
                        params.departuredate && moment(params.departuredate),
                    };

                    // Values if user comes from other step
                    const prepopularedFields = {
                      initialStartDate: startDate && moment(startDate),
                      initialEndDate: endDate && moment(endDate),
                    };

                    let additionalProps = {};

                    // The filled fields have priority over the QQ parameters.
                    if (context.state.vacationData.checkInDate) {
                      additionalProps = prepopularedFields;
                    } else {
                      additionalProps = quickQuoteParams;
                    }

                    const ssv = context.state.fields.rstCode === 'ssv' ? true : false;

                    return (
                      <DateRangePicker
                        onChange={context.onDateChange}
                        isCheckInDate={checkInDate}
                        isCheckOutDate={checkOutDate}
                        showWarningMessage={showLessThan3NightsWarning}
                        isSSV={ssv}
                        startFrom={fields.startFrom}
                        rstCode={fields.rstCode.toLowerCase()}
                        {...additionalProps}
                      />
                    );
                  }}
                </VacationContext.Consumer>
                {/* {isSandals && (
                  <p>
                    Flexible dates?
                    <a
                      className="blue-link"
                      href="https://www.sandals.com/flexible-dates/"
                    >
                      View Availability &amp; Price{' '}
                      <i className="icon-bold-arrow" />
                    </a>
                  </p>
                )} */}
              </div>
              <div className="group-divider"/>

              {/** VACATIONS FLIGHTS SECTION */}
              <VacationContext.Consumer>
                {(context) => {
                  const {
                    fieldValidations,
                    showFlightWarning,
                    fields,
                  } = context.state;
                  const { departure_airport } = fieldValidations;
                  const resortsGateways = this.state.resortGateways;
                  // const flightDisclamerDates = this.state.flightDisclamerDates // if they change there mind of this
                  //   .slice(0, -1)
                  //   .join(',')
                  //   .concat(
                  //     's, and ',
                  //     this.state.flightDisclamerDates.slice(-1) + 's'
                  //   );

                  let departureFrom = '';
                  let arrivingOptions = '';
                  const startDate = moment(context.state.fields.checkInDate, constants.DB_DATE_FORMAT);

                  let appliesForArrivalGateway = false;

                  // these code may return in the future - 13/10/23
                  // let canBookWithFlight = true;
                  // let saintVincentDates = '';

                  if (fields.rstCode) {
                    arrivingOptions = context.getArrivalAirport(
                      fields.rstCode,
                      resortsGateways
                    );
                  }

                  if (fields.checkInDate && fields.checkOutDate) {
                    appliesForArrivalGateway = true;
                    // appliesForArrivalGateway = this._applyForArrivalGatewayVerification( // if they change there mind of this
                    //   fields.checkInDate,
                    //   fields.checkOutDate,
                    //   '2023-04-01'
                    // );
                  }

                  /** change the rstCode verification for ssv */ // this code was commented beacause a change of rules from Mario K.
                  /* if (fields.checkInDate && fields.checkOutDate && fields.rstCode === 'ssv' && context.state.fields.airIncluded && Object.keys(this.state.saintVincentBookingDates).length > 0) {
                    const gateway = context.state.fields.departure_airport;

                    canBookWithFlight = this._applyForSanVincentGateway(fields.checkInDate, fields.checkOutDate, fields.rstCode, gateway);

                    if(!canBookWithFlight) {
                      // const validFlightDates = gateway ? this.state.saintVincentBookingDates[fields.rstCode] : {}; // this is the json disclaimer of the cnd
                      // const gatewaysDays = Object.keys(validFlightDates).length > 0 ? validFlightDates[gateway] : [];
                      // const shortDays = gatewaysDays.map((day) => day.slice(0, 3));
                      // const validDays = isTable ? shortDays : gatewaysDays;

                      saintVincentDates = (
                        <p className="flight-restriction">
                          <span className="restriction-dates">USA: Mon, Wed, Sat. {' '}</span>
                          <span className="restriction-dates">CANADA: Mon, Tue, Thu, and Fri.</span>
                        </p>
                      );
                    }
                  } */

                  /** Available SSV disclaimer */ // these code may return in the future - 13/10/23 
                  /* if(fields.rstCode === 'ssv' && context.state.fields.airIncluded) {
                    canBookWithFlight = false;

                    saintVincentDates = (
                      <p className="flight-restriction">
                        <span className="restriction-dates">USA: Mon, Wed, Sat. {' '}</span>
                        <span className="restriction-dates">CANADA: Mon, Tue, Thu, and Fri.</span>
                      </p>
                    );
                  } */

                  // The filled fields have priority over the QQ parameters.
                  if (context.state.vacationData.checkInDate) {
                    departureFrom = context.state.vacationData.departureFrom.toLowerCase();
                  } else {
                    departureFrom = params.arrival_gateway
                      ? params.arrival_gateway.toLowerCase()
                      : '';
                  }

                  let showAirportGateway = false;

                  /* eslint-disable camelcase */
                  if(fields.departure_airport) {
                    showAirportGateway = fields.departure_airport !== '';
                  }

                  return (
                    <div
                      className={`sm-12 md-11 lg-10 group ${
                        showFlightWarning ? 'reduce-top-padding' : ''
                      }`}
                    >
                      {showFlightWarning && (
                        <div className="sm-12 util-no-padding">
                          <p
                            className="fields-error flight-dates-error util-no-padding"
                            style={maxWidthStyle}
                          >
                            <i className="icon-information" />
                            {`To add flights to your booking, please select arrival date ${minFlightDate > startDate ? 'more than 14 days from today.' : 'less than 330 days from today.'} `}
                          </p>
                        </div>
                      )}
                      <div className="include-flights">
                        <div className="util-no-padding sm-12 md-6 lg-4 options-section">
                          <h3
                            className={`${
                              context.state.showFlightWarning ||
                              context.state.disableFlights
                                ? 'disabled'
                                : ''
                            } primary-heading flight-heading`}
                          >
                            Include Roundtrip Flights?
                          </h3>
                          <InputGroup
                            type="radio"
                            name="airIncluded"
                            onChange={(value, name) => {
                              this.updateFlightInfo(value, name, context);
                            }}
                            classList={['round-flights']}
                            options={[
                              {
                                label: 'No, thank you',
                                value: false,
                                attrs: {
                                  disabled:
                                    context.state.showFlightWarning ||
                                    context.state.disableFlights,
                                },
                              },
                              {
                                label: 'Yes, please',
                                value: true,
                                attrs: {
                                  disabled:
                                    context.state.showFlightWarning ||
                                    context.state.disableFlights,
                                },
                              },
                            ]}
                            value={[context.state.fields.airIncluded]}
                          />
                        </div>

                        {/* {!canBookWithFlight && ( // these code may return in the future - 13/10/23
                          <div className="sm-12 md-6 lg-6 saint-vincent-disclaimer">
                            <p className="disclaimer-mark">&#33;</p>
                            <div className="disclaimer-data">
                              Best arrivals + departure dates. {saintVincentDates}
                            </div>
                          </div>
                        )} */}
                      </div>

                      <Collapsible
                        expanded={context.state.fields.airIncluded}
                        title={''}
                      >
                        <form
                          className={'row flight-options'}
                          onSubmit={(e) => e.preventDefault()}
                        >
                          <FormGroup
                            type="autocomplete"
                            name="departure_airport"
                            onChange={(value, name) => {
                              this.updateFlightInfo(value, name, context);
                            }}
                            classList={
                              !departure_airport
                                ? ['is-invalid', 'gateways-select', 'autocomplete']
                                : ['gateways-select', 'autocomplete']
                            }
                            boxClassList={['sm-12', 'lg-6', 'departing']}
                            label="Flights departing from:"
                            attrs={{
                              placeholder: 'Enter City or Airport',
                              autoComplete: 'off',
                              maxLength: 50,
                            }}
                            dataList={this.state.gateways}
                            icon={['icon-pin']}
                            value={departureFrom ? departureFrom : context.state.fields.departure_airport}
                          />

                          <div className="form-group visible hidden-lg-up visible flight-results">
                            Results will be displayed in the "Flights" section.
                          </div>

                          <FormGroup
                            type="select"
                            name="flight_type"
                            onChange={(value, name) => {
                              this.updateFlightInfo(value, name, context);
                            }}
                            classList={['testing-classList']}
                            boxClassList={['sm-12', 'lg-6', 'flights-by']}
                            label="Search flights by:"
                            noDefault
                            options={[
                              {
                                label: 'Economy/Coach',
                                value: 'economy',
                              },
                              {
                                label: 'First Class/Business',
                                value: 'business',
                              },
                            ]}
                            value={[context.state.fields.flight_type]}
                          />

                          <div className="form-group visible hidden-lg-down flight-results">
                            Results will be displayed in the "Flights" section.
                          </div>
                          {showAirportGateway && appliesForArrivalGateway && arrivingOptions.length > 1 && (
                            <Fragment>
                              <FormGroup
                                type="select"
                                name="arrivalGateway"
                                onChange={(value, name) => {
                                  this.updateFlightInfo(value, name, context);
                                }}
                                boxClassList={['sm-12', 'lg-6', 'arriving']}
                                label="Airport arriving to:"
                                noDefault
                                options={arrivingOptions}
                                value={context.state.fields.arrivalGateway}
                              />
                              <div className="sm-12 lg-6 arriving-disclaimer"/>
                            </Fragment>
                          )}
                        </form>
                        {!departure_airport && (
                          <p className="is-invalid flight-error">
                            Invalid value or required field.
                          </p>
                        )}
                      </Collapsible>

                      {/*
                        <p className="fields-error util-txt-center sm-12">
                          Air Availability cannot be selected for dates more than 330 days from today. Your air selection has been deleted.
                        </p>
                      */}
                    </div>
                  );
                  /* eslint-enable camelcase */
                }}
              </VacationContext.Consumer>

              {!isSandals && (
                <Fragment>
                  <div className="group-divider"/>
                  <div className="sm-12 md-11 lg-10 group">
                    <VacationContext.Consumer>
                      {(context) => {
                        const { addGuestErrorDetails, isGuestControlOpen } = context.state;

                        const tooltipContent = (
                          <div className="vw-vctn adjoining-tooltip tooltip-content">
                            <div className="row util-no-side-margins util-space-between">
                              <h3 className="tip-heading">
                                How To Request Adjoining Rooms?
                              </h3>
                            </div>
                            <p className="tip-content">
                              Make two or more separate bookings and you will be
                              contacted by an agent after all your bookings are
                              complete. Adjoining rooms are not guaranteed as they may
                              be subject to availability.
                            </p>

                            <strong className="d-block">
                              Do you still want to request adjoining rooms for
                              multiple bookings?
                            </strong>

                            <div className="row">
                              <div className="sm-12 md-6">
                                <button
                                  onClick={() => this.toggleToolTip(context, 'false')}
                                  className="btn-primary no-btn"
                                >
                                  No, thank you
                                </button>
                              </div>
                              <div className="sm-12 md-6">
                                <button
                                  onClick={() => this.toggleToolTip(context, 'true')}
                                  className="btn-primary"
                                >
                                  Yes, please
                                </button>
                              </div>
                            </div>
                          </div>
                        );

                        const adjoiningRoomOptions = [
                          {
                            label: (
                              <Fragment>
                                <span className="gp-check-rooms">
                                  I would like to request adjoining rooms
                                </span>
                                <TooltipWrapper
                                  isOpen={this.state.isOpen}
                                  content={tooltipContent}
                                  withCloseButton
                                >
                                  <span
                                    name="toolTipSpan"
                                    onClick={() =>
                                      this.toggleToolTip(
                                        context,
                                        this.state.currentValue
                                      )
                                    }
                                  >
                                    <i className="icon-question-mark tooltip-icon" />
                                  </span>
                                </TooltipWrapper>
                              </Fragment>
                            ),
                            value: 'true',
                          },
                        ];

                        return (
                          <Fragment>
                            <AddGuests
                              openTooltipOnMount={this.state.isGuestControlOpen}
                              openThis={isGuestControlOpen}
                            />

                            <div className="util-txt-right">
                              {this._renderErrors(addGuestErrorDetails)}
                            </div>

                            <div className="vertical-padding">
                              <InputGroup
                                type="checkbox"
                                name="adjoiningRoom"
                                classList={['check-alt', 'gp-add-rooms']}
                                onChange={context.setInputValue}
                                value={[context.state.fields.adjoiningRoom]}
                                options={adjoiningRoomOptions}
                              />
                            </div>
                          </Fragment>
                        );
                      }}
                    </VacationContext.Consumer>
                  </div>
                </Fragment>
              )}
            </section>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default VacationDates;



// WEBPACK FOOTER //
// ./js/views/step1/VacationDates.js